import getFocusTrapEventHandler from './focus_trap'
import { preventOverflow } from './dropdown_menu_prevent_overflow'

const openedClass = 'opened'
const menuSelector = '.js-dropdown_menu'
const menuHeaderSelector = '.js-dropdown_menu_head'
const menuContentSelector = '.js-dropdown_menu_content'

const toggle = head => {
  const menu = head.closest(menuSelector)
  if (head.getAttribute('aria-expanded') !== 'true') {
    open(menu)
  } else {
    close(menu)
  }
}

up.compiler(menuHeaderSelector, function (element) {
  element.addEventListener('click', function (event) {
    event.preventDefault()
    toggle(element)
  })
})

up.on('click', '.js-close_dropdown_menu', (event, element) => {
  close(element.closest(menuSelector))
})

// close nav after clicking a link to make the website feel faster
up.on('click', '.js-dropdown_menu a', (event, element) => {
  close(element.closest(menuSelector))
})

up.on('click', '.js-dropdown_menu .js-dropdown_menu_item', (event, element) => {
  close(element.closest(menuSelector))
})

up.on('up:link:follow', '.js-dropdown_menu a', (event, element) => {
  close(element.closest(menuSelector))
})

function onMenuElementKeyDown(e) {
  const menuElement = e.currentTarget
  const { onFocus } = getFocusTrapEventHandler(menuElement)
  onFocus(e)
}

function doPreventOverflow(eventOrElement) {
  const element = eventOrElement.target || eventOrElement
  const head = element.querySelector(menuHeaderSelector)
  const content = element.querySelector(menuContentSelector)

  const horizontalAlign = element.dataset.horizontalAlign
  const expanded = head.getAttribute('aria-expanded') === 'true'

  if (head && content && horizontalAlign) {
    preventOverflow(horizontalAlign, expanded, head, content)
  }
}

export const open = function (element) {
  const { focusFirst } = getFocusTrapEventHandler(element)

  element.classList.add(openedClass)
  element.querySelector(menuHeaderSelector).setAttribute('aria-expanded', 'true')
  element.addEventListener('keydown', onMenuElementKeyDown)
  focusFirst()

  doPreventOverflow(element)
}

export const close = element => {
  element.classList.remove(openedClass)
  element.querySelector(menuHeaderSelector).setAttribute('aria-expanded', 'false')
  element.removeEventListener('keydown', onMenuElementKeyDown)
}

up.compiler(menuSelector, function (element) {
  const closeIfClickOutside = function (event) {
    if (!element.contains(event.target)) {
      close(element)
    }
  }

  const onResize = () => doPreventOverflow(element)
  window.addEventListener('click', closeIfClickOutside)
  window.addEventListener('resize', onResize)

  return () => {
    window.removeEventListener('click', closeIfClickOutside)
    window.removeEventListener('resize', onResize)
  }
})
